module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-end mt-5 mb-2 picker"
  }, [_c('div', {
    staticClass: "d-flex pointer bg-darkest align-items-center px-4 radius-normal medium normal",
    on: {
      "click": _vm.toggleAvailability
    }
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('i', {
    staticClass: "ico-calendar larger"
  }), _vm._v(" "), (_vm.dateFrom || _vm.dateTo) ? _c('span', [_vm._v(_vm._s(_vm.dateFrom) + " to " + _vm._s(_vm.dateTo))]) : _c('span', [_vm._v("(Pick a date ...)")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1ccbf08"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/AddFilters.vue
// module id = 1530
// module chunks = 0